import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from "@angular/core";
import { Utils } from "ng/src/app/core/utils";
import { Note } from "ng/src/app/notes/shared/note.model";
import { Subscription, timer } from "rxjs";
import { LogService } from "ng/src/app/logs/log.service";

@Component({
    selector: 'nsi-indicator',
    template: '<div #element class="nsi-indicator"></div>',
    styleUrls: ['./note-status-indicator.component.scss']
})
export class NoteStatusIndicatorComponent implements AfterViewInit, OnDestroy {
    @ViewChild('element') elRef!: ElementRef;
    
    @Input() note!: Note
    @Input() type!: 'CarryForward' | 'Updated'

    private _timerSubscription?: Subscription

    constructor() { }

    get element(): JQuery {
        return $(this.elRef.nativeElement);
    }

    get oopsEditMinutes(): number {
        return LogService.selectedLog?.oopsEditMinutes ?? 60000;
    }

    get currentTime(): Date {
        return new Date();
    }

    get carryForwardEnd(): Date | undefined {
        return this.note.carryForwardEndTime ? new Date(this.note.carryForwardEndTime) : undefined;
    }

    get updated(): Date {
        return new Date(this.note.updated);
    }

    get created(): Date {
        return new Date(this.note.created);
    }

    get modifiedRecently(): boolean {
        return this.updated &&
            this.created &&
            this.updated.getTime() - this.created.getTime() > this.oopsEditMinutes &&
            this.note.numRevisions > 1;
    }

    createTimer(due: Date | number, subscribe?: () => void) {
        const diff = +due - +new Date();
        // Check if date diff is greater than safe number
        if (!Utils.isSafeNumber(diff)) {
            //Add an hour to the current date to check if outside range
            due = new Date(+new Date() + 1000*60*60);
        }
        
        this._timerSubscription?.unsubscribe();
        this._timerSubscription = timer(due).subscribe(subscribe);
    }

    setCarryForwardColor() {
        const endDate = this.carryForwardEnd;
        const elem = this.element;

        if ( this.note.carryForward && (!endDate || endDate > this.currentTime) )
        {
            elem.css('background-color', 'red');
            elem.attr('title', 'Active Carry Forward');

            if (endDate)
                this.createTimer(endDate, () => this.setCarryForwardColor());
        }
        else if ( endDate && endDate < this.currentTime )
        {
            elem.css('background-color', 'blue');
            elem.attr('title', 'Ended Carry Forward');
        }
        else
        {
            elem.css('background-color', 'initial');
            elem.removeAttr('title');
        }
    }

    setUpdatedColor() {
        const elem = this.element;

        if ( this.note.newMillis )
        {
            elem.css('background-color', '#777');
            elem.attr('title', this.modifiedRecently ? 'Recently Modified' : 'New Note');
            this.createTimer(this.note.newMillis, () => {
                this.note.newMillis = 0;
                this.setUpdatedColor();
            });
        }
        else if ( this.modifiedRecently )
        {
            elem.css('background-color', '#ccc');
            elem.attr('title', 'Modified');
        }
        else
        {
            elem.css('background-color', 'initial');
            elem.removeAttr('title');
        }
    }

    ngAfterViewInit(): void {
        if (!(this.note && this.type)) return;

        if (this.type === 'CarryForward')
            this.setCarryForwardColor();

        else if (this.type === 'Updated')
            this.setUpdatedColor();
    }

    ngOnDestroy(): void {
        this._timerSubscription?.unsubscribe();
    }

}